module.exports = __webpack_public_path__ + "fonts/Ubuntu-Italic.1f4ab19.woff";